import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CandidateForm from "./components/CandidateForm";
import Index from "./components/Index";
import Technical from "./components/Technical";
import Digital from "./components/Digital";
import Hardware from './components/Hardware';
import Ques from './components/Ques';
import Admin from './components/Admin';
import EmpDetail from './components/EmpDetail';
import ThankYou from './components/ThankYou';
import Result from './components/Result';
import Developer from './components/Developer';
import Login from './components/Login'; // Import the Login component
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute

function App() {
  return (
    <>
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<CandidateForm />} />
          <Route path="/index" element={<Index />} />
          <Route path="/technical" element={<Technical />} />
          <Route path="/digital" element={<Digital />} />
          <Route path="/hardware" element={<Hardware />} />
          <Route path="/ques" element={<Ques />} />
          <Route path="/admin/login" element={<Login />} /> {/* New login route */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          /> {/* Protected admin route */}
          <Route path="/emp-detail/:empId" element={<EmpDetail />} />
          <Route path="/thankyou" element={<ThankYou/>} />
          <Route path="/results/:cid/:date/:testName" element={<Result />} />
          <Route path="/developer" element={<Developer />} />
        </Routes>
      </Router>
    </div>
    </>
  );
}

export default App;
